import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { push } from 'connected-react-router';
import { updateBrandOptionsForm, fetchBrand } from 'services/brands/duck';
import EditBrandOptionsForm from 'components/organisms/forms/EditBrandOptions';
import BrandTabView from 'components/organisms/brand/BrandTabView';

const formName = 'editBrandOptions';
const formSelector = formValueSelector(formName);

class EditBrandOptionsContainer extends Component {
    componentDidMount() {
        const brandId = this.props.match.params.id;

        if (this.props.fetchBrand && brandId) {
            this.props.fetchBrand({ brandId });
        }
    }

    render() {
        return (
            <BrandTabView selected="options" brand={this.props.brand} push={this.props.push}>
                <EditBrandOptionsForm
                    brand={this.props.brand}
                    whitelabelDomain={this.props.whitelabelDomain}
                    theme={this.props.theme}
                    dispatch={this.props.dispatch}
                    pristine={this.props.pristine}
                    selectedLabelCode={this.props.selectedLabelCode}
                    handleSubmit={this.props.handleSubmit.bind(null, updateBrandOptionsForm)}
                >
                </EditBrandOptionsForm>
            </BrandTabView>
        );
    }
}

const mapStateToProps = state => ({
    brand: state.brands.brand,
    whitelabelDomain: state.config.whitelabelDomain,
    initialValues: state.brands.brand,
    selectedLabelCode: formSelector(state, 'meta.programmaticObjective.labelCode'),
});


export default compose(
    connect(mapStateToProps, { push, fetchBrand }),
    reduxForm({
        form: formName,
        enableReinitialize: true
    })
)(EditBrandOptionsContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/brands/EditBrandOptionsContainer.js